export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

export function addApiError(pathName, error) {
  return (dispatch) =>
    dispatch(addError(pathName, error));
}

export function removeApiError(pathName) {
  return (dispatch) =>
    dispatch(removeError(pathName));
}

function addError(pathName, error) {
  return {
    type: ADD_ERROR,
    payload: error,
    pathName,
  };
}

function removeError(pathName) {
  return {
    type: REMOVE_ERROR,
    pathName,
  };
}



// WEBPACK FOOTER //
// ./data/ApiError/actions.js